export const RevenueSearchRoute = {
  path: '/order/search',
  load: () => import('./RevenueSearch'),
  protected: true,
};

export const NewRevenueSearchRoute = {
  path: '/order/search/new',
  load: () => import('./RevenueSearchNew'),
  protected: true,
};
